import React from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';

import Block from 'components/common/block';
import { ReactComponent as TrashIcon } from 'assets/vectors/remove-16px.svg';
import { ReactComponent as AddIcon } from 'assets/vectors/add-green-16px.svg';
import { ReactComponent as ReducerIcon } from 'assets/vectors/reducerIcon.svg';

import ReducersModal from './reducersModal';

const ArchiveStsProjectEquipment = gql`
  mutation ArchiveStsProjectEquipment($input: ArchiveStsProjectEquipmentInput!) {
    archiveStsProjectEquipment(archiveStsProjectEquipmentData: $input) {
      success
    }
  }
`;

const GetReducers = gql`
  query StsProjectEquipments ($sortBy: [String], $stsprojectId: ID){
    stsprojectEquipments(sortBy: $sortBy, stsprojectId: $stsprojectId) {
      edges {
        node {
          id
          reducer {
            id
            plNumber
            serialNumber
            length
            material
            aConnection
            aFlange
            bConnection
            bFlange
            location
          }
        }
      }
    }
  }
`;

function Reducers({ projectId, onAdd, allowEdit }) {
  const [showReducersModal, setShowReducersModal] = React.useState(false);

  const {data, refetch} = useQuery(GetReducers, {
    variables: {
      stsprojectId: projectId,
      sortBy: ['created desc']
    },
    onError(e) {
      console.log(e);
    }
  });

  const [executeArchiveStsProjectEquipment, { loading: archiveLoading }] = useMutation(ArchiveStsProjectEquipment, {
    onCompleted() {
      refetch();
    }
  });

  function addReducer() {
    setShowReducersModal(true);
  }

  function removeReducer(equipmentId) {
    executeArchiveStsProjectEquipment({
      variables: {
        input: {
          stsprojectEquipmentId: equipmentId,
        }
      }
    })
  }

  const projectEquipments = data ? data.stsprojectEquipments.edges.map(r => r.node).filter(r => !!r.reducer) : [];
  const addedReducers = projectEquipments.map(r => r.reducer.id);

  return (
    <StyledBlock title={<BlockTitle><ReducerIcon style={{ marginRight: '8px'}} /> Reducers</BlockTitle>}>
      <TableContainer>
        <Table aria-label="simple table" style={{ whiteSpace: 'nowrap' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                PL Nr.
              </TableCell>
              <TableCell>
                Serial Nr.
              </TableCell>
              <TableCell>
                Length
              </TableCell>
              <TableCell>
                Material
              </TableCell>
              <TableCell>
                Connection A
              </TableCell>
              <TableCell>
                Flange A
              </TableCell>
              <TableCell>
                Connection B
              </TableCell>
              <TableCell>
                Flange B
              </TableCell>
              <TableCell>
                Location
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
          {
              !projectEquipments.length
                ? <TableRow>
                    <TableCell>None added</TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                : (
                  projectEquipments.map(equipment => (
                    <TableRow key={equipment.id}>
                      <TableCell>
                        <Link href={`/dashboard/equipment/reducers/${equipment.reducer.id}`} target="_blank">{equipment.reducer.plNumber}</Link>
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.serialNumber}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.length}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.material}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.aConnection}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.aFlange}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.bConnection}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.bFlange}
                      </TableCell>
                      <TableCell>
                        {equipment.reducer.location}
                      </TableCell>
                      <TableCell align="right">
                        {
                          allowEdit && (
                            <IconButton
                              onClick={() => removeReducer(equipment.id)}
                              aria-label="delete reducer"
                              className="deleteButton"
                              disabled={archiveLoading}
                            >
                              <TrashIcon />
                            </IconButton>
                          )
                        }
                      </TableCell>
                    </TableRow>
                  ))
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        allowEdit && (
          <ButtonWrapper>
            <Button
              variant="outlined"
              color="primary"
              onClick={addReducer}
              endIcon={<AddIcon />}
            >
            Add reducer
            </Button>
          </ButtonWrapper>
        )
      }
      { showReducersModal && <ReducersModal setShowReducersModal={setShowReducersModal} projectId={projectId} refetch={refetch} addedReducers={addedReducers} onAdd={onAdd} /> }
    </StyledBlock>
  );
}

const BlockTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.textColor};
`;

const StyledBlock = styled(Block)`
  width: 1080px;
  max-width: 100%;
  margin-bottom: 16px;
`;

const Link = styled.a`
  color: ${props => props.theme.colors.primaryColor};
  text-decoration: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;

  @media (${props => props.theme.breakpoints.tablet}) {
    justify-content: flex-start;
  }
`;

export default Reducers;
